import { render, staticRenderFns } from "./brandy-bottle.vue?vue&type=template&id=e2aa3e44"
import script from "./brandy-bottle.vue?vue&type=script&lang=js"
export * from "./brandy-bottle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports